import { DeliveryRequestItem } from '../../../../@types/model/deliveryRequest';
import { DeliverFilter } from '../../../../@types/model/deliver';
import { RefactoredDevice } from '../../../../@types/model/device';

/**
 * Función para detectar se debemos desactivar o no el botón de eliminar slot en cada dispositivo.
 * @param tableFilter Tabla con los filtros
 * @param deliveryRequestItems Lista de slots que se meteran en el camion
 * @param rd RefactoredDevice, es decir, el dispositivo en questión
 * @returns boolean true si debe desactivarse el botón, o false si se debe permitir eliminar slots.
 */
const getDisabledRemove = (
  tableFilter: DeliverFilter,
  deliveryRequestItems: DeliveryRequestItem[],
  rd: RefactoredDevice
) => {
  if (
    !deliveryRequestItems.filter((dri: DeliveryRequestItem) => {
      if (rd.attributes.is_ref_of && rd.attributes.is_ref_of.split(':').length === 3)
        return dri.device === rd.attributes.is_ref_of.split(':')[2];
      else return dri.device === rd.guid;
    }).length
  )
    return true;
  if (!tableFilter.deliveryConfiguration) return true;
  if (!tableFilter.deviceGroup) return true;
  if (!rd.productSchedule) return true;
  return false;
};

export default getDisabledRemove;
